/* eslint-disable graphql/template-strings */
import gql from 'graphql-tag';

import gbxMetaTagsQuery from './shared/gbxMetaTagsQuery';
import { SubscriptionCheckoutPage } from './shared/subscriptionCheckoutPageFragment';

const GET_ORGANIC_PAGES = gql`
  query gbxOrganicUpgradePages {
    me {
      id
      layout {
        useNewMembershipConfirmationPage
        gbxOrganicUpgradePage {
          landingPage {
            cmsIdentifier
            heroImgDesktop {
              src
              alt
              width
              height
            }
            heroImgMobile {
              src
              alt
              width
              height
            }
            header
            explanatory
            valueProperty
            upgradePrice
            buttonCta
            learnMore {
              header
              explanatory
              bulletPoints
            }
            bulletPoints
          }
          checkoutPage {
            cmsIdentifier
            header
            subHeader
            upgradeProgram
            upgradePrice
            paymentIcon {
              src
              alt
              width
              height
            }
            paymentInfo
            cancellation
            notificationBulletPoints
            subscriptionDisclaimer
            shippingDisclaimer
            shippingLearnMore
            buttonCta
            info {
              header
              bulletPoints
            }
            paymentError
            paymentErrorMsg
          }
        }
        paymentRetrialEnabled: globalVariable(
          key: "PUBLIC_PAYMENT_RETRIAL_EXPERIENCE"
        )
        ...gbxMetaTagsQuery
      }
    }
  }
  ${gbxMetaTagsQuery}
`;

/**
 * Query used in the organic checkout page.
 * The user can get there from a link in an email by skipping the landing page.
 */
export const GET_ORGANIC_CHECKOUT_PAGE = gql`
  ${SubscriptionCheckoutPage}
  query gbxOrganicCheckoutPage(
    $dExperiment: DExperiment
    $subscriptionCheckoutCmsIdentifier: String
  ) {
    me {
      id
      subscriptions {
        id
        program
        status
        shippingAddress {
          country
        }
      }
      layout {
        useNewMembershipConfirmationPage
        ...subscriptionCheckoutQuery

        gbxOrganicUpgradePage(dExperiment: $dExperiment) {
          checkoutPage {
            paymentIcon {
              src
              alt
              width
              height
            }
            paymentInfo
            paymentError
          }
        }
        paymentRetrialEnabled: globalVariable(
          key: "PUBLIC_PAYMENT_RETRIAL_EXPERIENCE"
        )
        ...gbxMetaTagsQuery
      }
    }
  }
  ${gbxMetaTagsQuery}
`;

export default GET_ORGANIC_PAGES;
